module.exports = __webpack_public_path__ + "img/basic.d589bcbc.svg";